// extracted by mini-css-extract-plugin
module.exports = {"codeSnippet":"CodeSnippet_codeSnippet__1zpFc","copyIcon":"CodeSnippet_copyIcon__3JLPR"};